export interface FlashItem {
  time: string;
  tag: string;
  status: "实锤" | "发酵" | "待核实";
  text: string;
}

export interface TodayNews {
  cover: string;
  category: string;
  title: string;
  excerpt: string;
  read: string;
  comments: string;
  status: "实锤" | "发酵" | "待挖";
}

export interface RankItem {
  rank: number;
  name: string;
  heat: string;
  delta: number;
  discuss: string;
}

export interface ThreadItem {
  topic: string;
  title: string;
  author: string;
  replies: string;
  views: string;
  tags: string[];
  voteA: string;
  voteB: string;
  ratioA: number;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const siteStats = {
  flashes: "128",
  updates: "36",
  online: "2.4w",
  fans: "18.6w",
};

export const heroWatch: FlashItem = {
  time: "刚刚",
  tag: "独家",
  status: "发酵",
  text: "红毯后台连麦 3 分钟原声流出，顾言川回应新片选角：暂不方便透露，档期定了会第一时间说。",
};

export const tickerItems: string[] = [
  "影展红毯夜话：顾言川一句回应冲上热搜",
  "《今夜有约》录制生图流出，陈黛妆造变化引围观",
  "苏禾片场夜戏花絮被拍，粉丝在评论区分成两派",
  "颁奖礼提名名单疑似提前泄出，官方暂未回应",
  "江叙新专辑被追问档期，后台只说再等等",
  "沈知遥品牌活动未播片段流出，现场气氛热烈",
  "《闪闪的我们》下期录制场馆外已开始排队",
];

export const flashes: FlashItem[] = [
  { time: "08:32", tag: "红毯", status: "实锤", text: "顾言川红毯采访原声全片放出，回应新片选角传闻，句句没松口但态度明显缓和。" },
  { time: "08:05", tag: "片场", status: "发酵", text: "苏禾深夜片场照片外流，身后布景被网友放大比对，疑似为《回响》第三单元。" },
  { time: "07:44", tag: "综艺", status: "实锤", text: "《今夜有约》官方确认下期飞行嘉宾共 5 人，网传名单与现场排班一致。" },
  { time: "07:12", tag: "舞台", status: "待核实", text: "音乐节主办方回应网络票务异常：技术升级导致排队，非内部放票，补偿方案稍后公布。" },
  { time: "06:50", tag: "商务", status: "发酵", text: "江叙代言的国货品牌官宣物料替换，新旧海报对比在评论区吵了起来。" },
  { time: "06:28", tag: "颁奖礼", status: "待核实", text: "颁奖礼提名名单截图流传，主办方表示以 19 号红毯后官宣为准。" },
  { time: "06:05", tag: "红毯", status: "实锤", text: "沈知遥压轴红毯 40 秒高清片段补发，珠宝特写镜头成为今日名场面。" },
  { time: "05:37", tag: "片场", status: "发酵", text: "《闪闪的我们》录制地贴出设备调度单，网友据此猜测下期主题与露营有关。" },
];

export const todayNews: TodayNews[] = [
  {
    cover: "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20photography%20of%20a%20glamorous%20night%20red%20carpet%20event%2C%20blurred%20crowd%20and%20camera%20flashes%20as%20soft%20gold%20bokeh%20in%20background%2C%20no%20recognizable%20faces%2C%20warm%20crimson%20and%20amber%20cinematic%20grade%2C%20premium%20entertainment%20news%20aesthetic%2C%20rich%20dark%20tonal%20contrast%2C%20high%20detail&width=1200&height=800&seq=cg-cover-01&orientation=landscape",
    category: "红毯",
    title: "影展红毯夜话：顾言川一句回应冲上热搜",
    excerpt: "红毯后台连麦 3 分钟原声流出，关于新片选角他既没承认也没否认，只留给镜头一个侧脸。",
    read: "6.4w",
    comments: "3128",
    status: "实锤",
  },
  {
    cover: "https://readdy.ai/api/search-image?query=stylized%20editorial%20photography%20of%20a%20moody%20night%20film%20set%20with%20studio%20lamps%20and%20empty%20director%20chairs%2C%20no%20people%20faces%2C%20warm%20golden%20and%20deep%20red%20lighting%2C%20cinematic%20atmosphere%2C%20film%20production%20behind%20the%20scenes%2C%20soft%20grain%2C%20premium%20entertainment%20editorial%20aesthetic&width=1200&height=800&seq=cg-cover-02&orientation=landscape",
    category: "片场",
    title: "苏禾深夜片场被拍，背景布景引网友逐格比对",
    excerpt: "一张深夜片场照让剧粉连夜开工，反复对照分镜后推测可能属于《回响》第三单元。",
    read: "4.1w",
    comments: "1987",
    status: "发酵",
  },
  {
    cover: "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20premium%20variety%20show%20studio%20with%20warm%20spotlights%20and%20decorative%20stage%20lights%20glowing%20amber%20and%20red%2C%20empty%20audience%20seats%2C%20no%20recognizable%20faces%2C%20cinematic%20television%20production%20scene%2C%20soft%20bokeh%2C%20rich%20warm%20tonal%20grade%2C%20entertainment%20news%20aesthetic&width=1200&height=800&seq=cg-cover-03&orientation=landscape",
    category: "综艺",
    title: "《今夜有约》下期生图曝光，陈黛妆造变化大",
    excerpt: "录制现场流出的两张生图里，陈黛一改短发造型，高马尾造型让讨论区立刻沸腾。",
    read: "5.7w",
    comments: "2764",
    status: "实锤",
  },
  {
    cover: "https://readdy.ai/api/search-image?query=stylized%20editorial%20photography%20of%20a%20grand%20awards%20gala%20hall%20with%20warm%20gold%20and%20crimson%20decorations%2C%20empty%20stage%20with%20golden%20trophy%20silhouette%2C%20no%20people%2C%20cinematic%20lighting%20with%20soft%20bokeh%2C%20premium%20entertainment%20award%20ceremony%20aesthetic%2C%20rich%20dark%20tonal%20grade&width=1200&height=800&seq=cg-cover-04&orientation=landscape",
    category: "颁奖礼",
    title: "颁奖礼提名名单疑似提前泄出，官方沉默",
    excerpt: "一份疑似内部提名截图在群聊里流转，主办方既没承认也没辟谣，评论区吵到半夜。",
    read: "8.2w",
    comments: "4210",
    status: "待挖",
  },
  {
    cover: "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20warm%20music%20festival%20stage%20at%20dusk%20with%20crowd%20silhouettes%20and%20glowing%20amber%20and%20red%20lights%2C%20no%20recognizable%20faces%2C%20cinematic%20concert%20atmosphere%2C%20soft%20grain%2C%20premium%20music%20entertainment%20news%20aesthetic%2C%20rich%20warm%20tonal%20grade&width=1200&height=800&seq=cg-cover-05&orientation=landscape",
    category: "舞台",
    title: "音乐节后台连麦半小时，江叙被追问新专辑",
    excerpt: "现场切播后台画面时江叙恰好在线，主持人一句追问让他笑着把话题绕了三圈。",
    read: "3.9w",
    comments: "1563",
    status: "发酵",
  },
  {
    cover: "https://readdy.ai/api/search-image?query=stylized%20editorial%20photography%20of%20an%20elegant%20private%20brand%20event%20with%20flower%20arrangements%20and%20candlelight%2C%20glasses%20and%20fine%20details%20on%20a%20table%2C%20no%20people%20faces%2C%20warm%20golden%20and%20soft%20red%20lighting%2C%20luxury%20lifestyle%20aesthetic%2C%20cinematic%20depth%20of%20field%2C%20premium%20entertainment%20editorial%20style&width=1200&height=800&seq=cg-cover-06&orientation=landscape",
    category: "商务",
    title: "沈知遥品牌活动未播片段流出，现场气氛拉满",
    excerpt: "一段未进正片的互动花絮被人悄悄放出来，全程高能，看过的都在问完整版在哪。",
    read: "3.2w",
    comments: "1108",
    status: "实锤",
  },
];

export const rankList: RankItem[] = [
  { rank: 1, name: "顾言川新片选角回应", heat: "428w", delta: 0, discuss: "3.1w" },
  { rank: 2, name: "颁奖礼提名名单疑似流出", heat: "396w", delta: 1, discuss: "2.7w" },
  { rank: 3, name: "陈黛综艺高马尾造型", heat: "311w", delta: -1, discuss: "2.2w" },
  { rank: 4, name: "苏禾片场深夜花絮", heat: "289w", delta: 2, discuss: "1.9w" },
  { rank: 5, name: "江叙后台被追问新专辑", heat: "247w", delta: 0, discuss: "1.6w" },
  { rank: 6, name: "沈知遥品牌活动名场面", heat: "205w", delta: 3, discuss: "1.4w" },
  { rank: 7, name: "音乐节票务补偿方案", heat: "168w", delta: -2, discuss: "1.1w" },
  { rank: 8, name: "《今夜有约》飞行嘉宾官宣", heat: "142w", delta: 1, discuss: "8.9k" },
  { rank: 9, name: "颁奖礼红毯压轴悬念", heat: "109w", delta: -3, discuss: "7.2k" },
  { rank: 10, name: "国货品牌物料更换疑云", heat: "86w", delta: 0, discuss: "5.6k" },
];

export const threads: ThreadItem[] = [
  {
    topic: "围观台",
    title: "投票：今晚这瓜，你觉得明天会不会反转？",
    author: "一颗酸梅",
    replies: "1284",
    views: "6.3w",
    tags: ["今晚话题", "热度高"],
    voteA: "稳了，实锤证据够硬",
    voteB: "说不准，等官方回应",
    ratioA: 62,
  },
  {
    topic: "实锤区",
    title: "逐帧整理：苏禾片场照的时间线梳理",
    author: "吃瓜老树",
    replies: "906",
    views: "4.8w",
    tags: ["时间线", "考据"],
    voteA: "梳理得很清楚",
    voteB: "还有遗漏我再补",
    ratioA: 71,
  },
  {
    topic: "澄清贴",
    title: "关于「红毯选角」，顾言川那段话到底怎么理解",
    author: "今晚不睡",
    replies: "743",
    views: "3.1w",
    tags: ["文本解析", "冷静"],
    voteA: "别过度解读",
    voteB: "但话确实有信息量",
    ratioA: 54,
  },
  {
    topic: "现场线报",
    title: "《闪闪的我们》录制场馆外实时排队播报",
    author: "蹲点小能手",
    replies: "521",
    views: "2.7w",
    tags: ["现场", "实时"],
    voteA: "今天人没想象中多",
    voteB: "晚点大概率会爆",
    ratioA: 58,
  },
];

export const trustPoints = [
  {
    icon: "ri-shield-check-line",
    title: "信源标注",
    desc: "每条快讯都注明来源类别与流传范围，官方口径与非官方爆料在页面上分得清清楚楚。",
  },
  {
    icon: "ri-eye-line",
    title: "分级核实",
    desc: "内容统一打上「实锤 / 发酵 / 待核实」标签，没坐实的事绝不标题党盖章。",
  },
  {
    icon: "ri-community-line",
    title: "讨论留白",
    desc: "我们负责把时间线捋直，把判断权交回评论区，不预设立场、不替谁站台。",
  },
  {
    icon: "ri-refund-2-line",
    title: "即时订正",
    desc: "一旦出现反转或新进展，会第一时间在原位置补更正条，保留原始记录。",
  },
];

export const faqList: FaqItem[] = [
  {
    q: "擦边吃瓜是做什么的？",
    a: "这里围绕娱乐、红毯、综艺、片场与舞台的动态做实时整理与讨论，把零散信息拼成时间线，方便你快速看全一场瓜的来龙去脉。",
  },
  {
    q: "「实锤、发酵、待核实」有什么区别？",
    a: "实锤指有官方或多方证据链支撑；发酵指讨论正在升温、尚无定论；待核实指线索刚冒头，正在取证，提醒你先看别急着下结论。",
  },
  {
    q: "资讯多久更新一次？",
    a: "实时快讯流按分钟滚动更新，重大进展会插队置顶；今日板块则汇总当天值得二刷的完整事件，早晚各归纳一轮。",
  },
  {
    q: "我可以参与爆料或补充线索吗？",
    a: "评论区随时可补充时间线或指正细节。涉及个人隐私、未经证实的指控会被拦截，本站只做公开信息的整理与讨论。",
  },
  {
    q: "资讯内容是官方的吗？",
    a: "不是。官方内容均会单独标注来源链接；其余为公开渠道整理与网友讨论，请以官方口径为最终依据。",
  },
];

export const brandWords = {
  tagline: "新瓜不隔夜，实时跟上不掉队",
  note: "我们只做一件事：把今天散落的瓜，一根线串到你面前。",
};